import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorStateService {
  private errorCode: number | null = null;

  private errorMessage: string | null = null;

  setError(error: HttpErrorResponse): void {
    this.errorCode = error.status;
    this.errorMessage = error.error.message;
  }

  hasErrorMessage(): boolean {
    return !!this.errorMessage && !!this.errorCode;
  }

  getErrorMessage(): string | null {
    return this.errorMessage;
  }

  getErrorCode(): number | null {
    return this.errorCode;
  }

  clearErrorMessage(): void {
    this.errorMessage = null;
    this.errorCode = null;
  }
}
